const ALGORITHM = 'AES-GCM';
const IV_LENGTH = 16;
let secretKey = null;


export const initCrypto = async (secret) => {
   if (!secret) throw new Error('Secret key is required');
  
   try {
       const keyBuffer = new TextEncoder().encode(secret);
      
       if (keyBuffer.length !== 32) {
           throw new Error('Secret key must be exactly 32 bytes (256 bits)');
       }


       secretKey = await crypto.subtle.importKey(
           'raw',
           keyBuffer,
           { name: ALGORITHM },
           false,
           ['encrypt', 'decrypt']
       );
   } catch (error) {
       console.error('Crypto init error:', error);
       throw error;
   }
};


export const encryptData = async (data) => {
   if (!secretKey) throw new Error('Crypto not initialized');
  
   try {
       const iv = crypto.getRandomValues(new Uint8Array(IV_LENGTH));
       const dataString = JSON.stringify(data);
      
       const encrypted = await crypto.subtle.encrypt(
           { name: ALGORITHM, iv },
           secretKey,
           new TextEncoder().encode(dataString)
       );
      
       const encryptedArray = new Uint8Array(encrypted);
       const authTag = encryptedArray.slice(-16);
       const encryptedData = encryptedArray.slice(0, -16);
      
       return JSON.stringify({
           IV: arrayBufferToBase64(iv),
           encryptedData: arrayBufferToBase64(encryptedData),
           authTag: arrayBufferToBase64(authTag)
       });
   } catch (error) {
       console.error('Encryption error:', error);
       throw error;
   }
};


export const decryptData = async (encryptedPayload) => {
   if (!secretKey) throw new Error('Crypto not initialized');
  
   try {
       const { IV, encryptedData, authTag } = JSON.parse(encryptedPayload);
       if (!IV || !encryptedData || !authTag) {
           throw new Error('Invalid payload');
       }
      
       const iv = base64ToArrayBuffer(IV);
       const encrypted = base64ToArrayBuffer(encryptedData);
       const tag = base64ToArrayBuffer(authTag);
      
       const combined = new Uint8Array(encrypted.byteLength + tag.byteLength);
       combined.set(new Uint8Array(encrypted), 0);
       combined.set(new Uint8Array(tag), encrypted.byteLength);
      
       const decrypted = await crypto.subtle.decrypt(
           { name: ALGORITHM, iv },
           secretKey,
           combined
       );
      
       return JSON.parse(new TextDecoder().decode(decrypted));
   } catch (error) {
       console.error('Decryption error:', error);
       throw error;
   }
};


const arrayBufferToBase64 = (buffer) => {
   return btoa(String.fromCharCode(...new Uint8Array(buffer)));
};


const base64ToArrayBuffer = (base64) => {
   const binary = atob(base64);
   const bytes = new Uint8Array(binary.length);
   for (let i = 0; i < binary.length; i++) {
       bytes[i] = binary.charCodeAt(i);
   }
   return bytes.buffer;
};


export const CryptoService = {
   init: initCrypto,
   encrypt: encryptData,
   decrypt: decryptData
};

